import { render, staticRenderFns } from "./form-props.vue?vue&type=template&id=f9098ce2&"
import script from "./form-props.vue?vue&type=script&lang=js&"
export * from "./form-props.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports